import React, { Component } from 'react'
import { connect } from 'react-redux'

import Modal from './Modal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'

import {
	showModalConfirmarAccion
} from '../../actions/common'

class ModalConfirmarAccion extends Component {
	handleCloseModal = (e) => {

		const modal = document.getElementById('modalConfirmarAccion')

		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalConfirmarAccion .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.showModalConfirmarAccion(false), 300)
		
	}

	render() {

		const { modalConfirmarAccion, children } = this.props

		if (!modalConfirmarAccion.get('show')) {
			return null
		}

		return(
			<Modal id="modalConfirmarAccion" show={ true } ZIndex={ 2000 } >

				<ModalHeader title="Confirmación" onClose={ (e) => this.handleCloseModal(e) } />

				<ModalBody>

					<div style={{ width: '600px' }}>
					
						<div className="row">
							<div className="col-md-12" style={{ color: '#000', fontWeight: '300' }}>								
								{
									modalConfirmarAccion.get('message') || 'Esta seguro que desea eliminar este registro?'
								}
							</div>
						</div>

						<div className="separator"></div>

						{ children }

					</div>

				</ModalBody>

				<ModalFooter>
					<button className="btn btn-default" type="button" onClick={ (e) => this.handleCloseModal(e) }>Cancelar</button>
					<button className="btn btn-default" type="button" onClick={ modalConfirmarAccion.get('action') }>Ok</button>
				</ModalFooter>

			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		modalConfirmarAccion: state.common.get('modalConfirmarAccion')
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		showModalConfirmarAccion: (open) => dispatch(showModalConfirmarAccion(open))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalConfirmarAccion)



// WEBPACK FOOTER //
// ./src/components/Shared/ModalConfirmarAccion.jsx